import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";
import AuthService from "./auth.service";

class SupplierService {
  getActives() {
    return axios
      .get(`${config.apiUrl}suppliers/actives`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error::", err.response.data);
        return [];
      });
  }

  index(params) {
    return axios
      .get(`${config["apiUrl"]}suppliers`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response?.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  create(bodyParms) {
    return axios
      .post(`${config["apiUrl"]}suppliers`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  update(id, bodyParms) {
    return axios
      .put(`${config["apiUrl"]}suppliers/${id}`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  query(params) {
    return axios
      .get(`${config["apiUrl"]}suppliers/query`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
}

export default new SupplierService();
